import { spacing } from "globalStyles";
import { ContactUsSection } from "interfaces/content";
import { useAppContext } from "providers/App";
import styled from "styled-components";
import { breakpoints } from "themes/breakpoints";
import FlexBox from "ui/FlexBox";
import Body from "ui/Text/Body";
import { parseToLinkType } from "utils/parse";
import { handleTextAndLinkType } from "../utils/content";

interface ContactUsProps {
  data: ContactUsSection["data"];
}

const ContactUs = ({ data }: ContactUsProps) => {
  const { content } = useAppContext();

  return (
    <Container className="anchor-offset">
      <InnerContainer className="content-container medium-padding">
        <FlexBox justify="flexStart" size="md">
          <Text variant="body2" color="tertiary">
            {data.title}
          </Text>
        </FlexBox>
        <Text variant="body2" color="tertiary" className="mail-text">
          {handleTextAndLinkType(
            parseToLinkType(content?.contacts.entity?.email || "", "email"),
          )}
        </Text>
      </InnerContainer>
    </Container>
  );
};

export default ContactUs;

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background.quaternary};

  .content-container.medium-padding {
    padding-top: ${spacing.medium}px;
    padding-bottom: ${spacing.medium}px;
  }
`;

const InnerContainer = styled.div`
  display: flex;

  .mail-text {
    margin-left: ${spacing.small}px;
  }

  @media (max-width: ${breakpoints.sm}) {
    flex-direction: column;

    .mail-text {
      margin-top: ${spacing.small}px;
      margin-left: 0;
      text-align: center;
    }
  }
`;

const Text = styled(Body)`
  font-weight: ${({ theme }) => theme.typography.fontWeights.semiBold};
`;
